<template>
    <div class="agencyCentre-wrapper agencyCentre-hostSubAgency-tabsScreen" style="background-color: #F2F2F2;">
        <div class="position-relative items-center agencyCentre-headerBar bg-white">
            <div class="angle black-angle" id="close" @click="goToAgencyCenter"></div>
            <div class="text-center agencyCentre-headerHD">My Hosts</div>
        </div>
        <div class="mt-2 agencyTeam-wrapper">
            <div class="agencyTeam-tabs" style="display: none !important;">
                <ul class="d-flex justify-content-start align-items-center gap-2 nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <div class="nav-link" :class="{ 'active': activeTab === 'hostList' }" @click="activateTab('hostList')" data-toggle="tab" href="#hostList" role="tab">Host List</div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link" :class="{ 'active': activeTab === 'subagency' }" @click="activateTab('subagency')" data-toggle="tab" href="#subagency" role="tab">Sub Agnecy</div>
                    </li>
                </ul>
            </div>
            <div class="tab-content pt-1">
                <div class="tab-pane" :class="{ 'active': activeTab === 'hostList' }" id="hostList" role="tabpanel">
                    <div v-if="isLoadedHostList">
                        <AgencyHostListTabCont />
                    </div>
                    
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'subagency' }" id="subagency" role="tabpanel">
                    <div v-if="isLoadedSubAgency">
                         <SubAgencyListTabCont />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import './AgencyCentreStyle.css'
import defaultUserImage from '../../assets/images/default_profile.webp';
import AgencyHostListTabCont from './AgencyHostListTabCont.vue';
import SubAgencyListTabCont from './SubAgencyListTabCont.vue';
export default {
    name: 'AgencyTeamList',
    components: {
        AgencyHostListTabCont,
        SubAgencyListTabCont
    },
    data() {
        return {
            defaultUserImage: defaultUserImage,
            isLoadedHostList: false,
            isLoadedSubAgency: false,
            activeTab: 'hostList',
        }
    },
    mounted () {
        this.isLoadedHostList = true;
    },
    methods: { 
        activateTab(tabId) {
            this.activeTab = tabId;
            if (tabId === 'hostList' && !this.isLoadedHostList) {
                this.isLoadedHostList = true;
            }
            if (tabId === 'subagency' && !this.isLoadedSubAgency) {
                this.isLoadedSubAgency = true;
            }
        },
        goToAgencyCenter() {
            // this.$router.push('/agency-centre');
            this.$router.go(-1);
        }
    }
}
</script>